const compose = function() {
  const fns = arguments;
  return (result) => {
    for (let i = fns.length - 1; i > -1; i--) {
      result = fns[i].call(this, result);
    }
    return result;
  };
};

export default compose;


// WEBPACK FOOTER //
// ./src/compose.js